module.exports = __webpack_public_path__ + "static/media/uncheckmarkedv2.b5061c0c.svg";